import { Box } from '@mui/material';
import { DatePickerActionsProps } from './DatePickerActions.types';

/**
 * DatePickerActions - Renders action buttons (Clear and Accept) for the date picker
 *
 * @component
 * @param {DatePickerActionsProps} props - Component props
 * @returns {JSX.Element} Action buttons container
 *
 * @example
 * <DatePickerActions onClear={() => {}} onAccept={() => {}} />
 */
export const DatePickerActions = ({ onClear, onAccept }: DatePickerActionsProps) => (
  <Box className="custom-date-picker-actions">
    <button className="custom-date-picker-btn clear" onClick={onClear}>
      Очистити
    </button>
    <button className="custom-date-picker-btn accept" onClick={onAccept}>
      Прийняти
    </button>
  </Box>
);
